import * as Network from '@root/entities/network/model/network'

import { PairAddress } from './PairAddress'

/**
 * The pair a url is showing, if it is showing one.
 *
 * Read before the application exists, so it cannot ask the router: the point
 * is to know which pair to fetch while React, the theme, the sockets and the
 * session are still being built. `/trade/:network/:pairAddress` and its v2
 * twin are the only two paths that name a pair.
 *
 * Imported by its own path rather than through the entity barrels, because
 * the one caller runs during boot and must not pull the pair entity in with
 * it.
 */
const PAIR_PATH = /^\/trade(?:-v2)?\/([^/]+)\/([^#/?]+)/

export const urlPair = (pathname: string) => {
  const match = PAIR_PATH.exec(pathname)
  if (!match) {
    return undefined
  }

  const [, networkSegment, addressSegment] = match
  if (!networkSegment || !addressSegment) {
    return undefined
  }

  /**
   * An unknown segment is not Solana.
   *
   * `fromPath` answers nothing for what it does not recognise, which is what
   * this wants: prefetching the wrong network's pair spends a request and
   * fills the registry with a pair the person did not ask for.
   */
  const network = Network.fromPath(networkSegment)
  if (network === undefined) {
    return undefined
  }

  return { network, address: PairAddress(addressSegment) }
}
